<div class="menu">
    <input type="checkbox" class="menu-open form-control" name="menu-open" id="menu-open" />
    <label class="btn ca-btn-icon ca-btn-icon-filled-primary menu-open-button" for="menu-open" data-uit="feedback-button">
        <ca-icon name="question-mark" size="l"></ca-icon>
    </label>
    <a
        *ngIf="hasHowToPermission && showTutorial && !isMEDProjectEnabled"
        class="btn ca-btn-icon ca-btn-icon-filled-primary menu-item how-to-item"
        ngbTooltip="{{ 'HOW_TO.TOOLTIP' | translate }}"
        container="body"
        routerLink="ai-toolkit/overview"
        placement="left"
    >
        <ca-icon name="path" size="s"></ca-icon>
    </a>
    <button
        class="btn ca-btn-icon ca-btn-icon-filled-primary menu-item contact-us-item"
        (click)="onContactClick()"
        ngbTooltip="{{ 'CONTACT_US.TOOLTIP' | translate }}"
        container="body"
        placement="left"
        triggers="hover"
        type="button"
        data-uit="contact-us-open-button"
    >
        <ca-icon name="envelope" size="s"></ca-icon>
    </button>
</div>
